"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var VideoCard =
/*#__PURE__*/
function (_Card$makeDefaultCard) {
  babelHelpers.inherits(VideoCard, _Card$makeDefaultCard);

  function VideoCard() {
    babelHelpers.classCallCheck(this, VideoCard);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(VideoCard).apply(this, arguments));
  }

  return VideoCard;
}(_base.default.makeDefaultCardType('video', 'Video', 'video', true));

exports.default = VideoCard;